<button
  [type]="type"
  class="eva-btn"
  [class.eva-btn--filled]="computedVariant === 'filled'"
  [class.eva-btn--soft]="computedVariant === 'soft'"
  [class.eva-btn--outlined]="computedVariant === 'outlined'"
  [class.eva-btn--text]="computedVariant === 'text'"
  [class.eva-btn--ghost]="computedVariant === 'ghost'"
  [class.eva-btn--link]="computedVariant === 'link'"
  [class.eva-btn--primary]="severity === 'primary'"
  [class.eva-btn--secondary]="severity === 'secondary'"
  [class.eva-btn--success]="severity === 'success'"
  [class.eva-btn--warning]="severity === 'warning'"
  [class.eva-btn--danger]="severity === 'danger'"
  [class.eva-btn--info]="severity === 'info'"
  [class.eva-btn--small]="size === 'small'"
  [class.eva-btn--medium]="size === 'medium'"
  [class.eva-btn--large]="size === 'large'"
  [class.eva-btn--icon-only]="isIconOnly"
  [class.eva-btn--rounded]="rounded"
  [class.eva-btn--block]="block"
  [class.eva-btn--loading]="loading"
  [class.eva-btn--disabled]="disabled || loading"
  [disabled]="disabled || loading"
  [evaTooltip]="computedTooltip"
  [evaTooltipPosition]="tooltipPosition"
  (click)="handleClick($event)"
>
  <!-- Loading spinner (remplace l'icône gauche) -->
  <ng-icon name="evaSpinner" class="eva-icon-spin eva-btn__spinner" *ngIf="loading && iconPos === 'left'"></ng-icon>

  <!-- Icon left - PrimeNG -->
  <i
    *ngIf="icon && iconPos === 'left' && !loading && !isHeroIcon"
    [class]="icon"
    class="eva-btn__icon"
    [style.color]="iconColor"
  ></i>

  <!-- Icon left - HeroIcons -->
  <ng-icon
    *ngIf="icon && iconPos === 'left' && !loading && isHeroIcon"
    [name]="icon"
    class="eva-btn__icon"
    [color]="iconColor ?? undefined"
  ></ng-icon>

  <!-- Label -->
  <span *ngIf="label" class="eva-btn__label">{{ label }}</span>

  <!-- Icon right - PrimeNG -->
  <i
    *ngIf="icon && iconPos === 'right' && !loading && !isHeroIcon"
    [class]="icon"
    class="eva-btn__icon"
    [style.color]="iconColor"
  ></i>

  <!-- Icon right - HeroIcons -->
  <ng-icon
    *ngIf="icon && iconPos === 'right' && !loading && isHeroIcon"
    [name]="icon"
    class="eva-btn__icon"
    [color]="iconColor ?? undefined"
  ></ng-icon>

  <!-- Loading spinner (position droite) -->
  <ng-icon name="evaSpinner" class="eva-icon-spin eva-btn__spinner" *ngIf="loading && iconPos === 'right'"></ng-icon>

  <!-- Badge compteur -->
  <span
    *ngIf="badge != null && badge !== 0 && badge !== '0' && badge !== ''"
    class="eva-btn__badge"
    [class.eva-btn__badge--primary]="badgeSeverity === 'primary'"
    [class.eva-btn__badge--secondary]="badgeSeverity === 'secondary'"
    [class.eva-btn__badge--success]="badgeSeverity === 'success'"
    [class.eva-btn__badge--warning]="badgeSeverity === 'warning'"
    [class.eva-btn__badge--danger]="badgeSeverity === 'danger'"
    [class.eva-btn__badge--info]="badgeSeverity === 'info'"
    >{{ badge }}</span
  >
</button>
